import { render, staticRenderFns } from "./qy.vue?vue&type=template&id=c3a76f72&scoped=true&"
import script from "./qy.vue?vue&type=script&lang=js&"
export * from "./qy.vue?vue&type=script&lang=js&"
import style0 from "./qy.vue?vue&type=style&index=0&id=c3a76f72&prod&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3a76f72",
  null
  
)

export default component.exports